import { EOLocale } from 'eo-locale';
import React from 'react';
import useLocales from '@react/hooks/useLocales';
import { useHabitat } from '@react/shared/HabitatContext';
const LocalisationProvider = ({ children }) => {
    const habitat = useHabitat();
    const cultureCode = habitat.cultureCode;
    const [locales] = useLocales();
    if (!locales || !locales.length) {
        // @todo: Optionally include loading state here.
        return null;
    }
    return (React.createElement(EOLocale.Provider, { language: cultureCode, locales: locales }, children));
};
export default LocalisationProvider;
